import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import { LabelList } from "recharts";

const Card = ({ title, subtitle, children }) => (
  <div className="bg-white/80 backdrop-blur border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
    <div className="mb-4">
      <h2 className="text-base font-semibold text-slate-800">{title}</h2>
      <p className="text-xs text-slate-500">{subtitle}</p>
    </div>
    {children}
  </div>
);

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border border-slate-200 shadow-lg rounded-lg p-3">
        <p className="text-xs text-slate-500">{label}</p>
        <p className="text-sm font-semibold text-slate-800">
          ₱{payload[0].value.toLocaleString()}
        </p>
      </div>
    );
  }
  return null;
};

export default function SalesByDueDateCharts({ data }) {
  if (!data) return null;

  return (
    <div className="mt-10">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">
          Projected Sales by Due Date
        </h1>
        <p className="text-slate-500 text-sm">
          Track projected revenue expected to close by the selected due date.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6">
        {/* Daily */}
        <Card title="Current Month" subtitle="All due days performance">
          {/* <ResponsiveContainer width="100%" height={280}>
            <LineChart data={data.projected_sales_due_date}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
              <XAxis dataKey="date" tick={{ fontSize: 12, fill: "#64748b" }} />
              <YAxis tick={{ fontSize: 12, fill: "#64748b" }} />
              <Tooltip content={<CustomTooltip />} />
              <Line
                type="monotone"
                dataKey="amount"
                stroke="#6366f1"
                strokeWidth={3}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer> */}
          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={data.projected_sales_due_date}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
              <XAxis dataKey="date" tick={{ fontSize: 12, fill: "#64748b" }} />
              <YAxis tick={{ fontSize: 12, fill: "#64748b" }} />
              <Tooltip content={<CustomTooltip />} />

              <defs>
                <linearGradient id="barColor" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#6366f1" stopOpacity={0.9} />
                  <stop offset="95%" stopColor="#6366f1" stopOpacity={0.3} />
                </linearGradient>
              </defs>

              <Bar
                dataKey="amount"
                fill="url(#barColor)"
                radius={[6, 6, 0, 0]}
                barSize={40}
              >
                <LabelList
                  className="hidden md:block"
                  dataKey="amount"
                  position="top"
                  formatter={(value) => `₱${value.toLocaleString()}`}
                  style={{ fontSize: 12, fill: "#334155", fontWeight: 500 }}
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Card>
      </div>
    </div>
  );
}
